var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageLayout } from '../Components/PageLayout';
import { NFTView } from '../Components/NFTView';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { useApplication } from '../Contexts/ApplicationContext';
import { PhoneStep } from '../../Services/controllers/StepController';
var Title = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 600;\n  color: ", ";\n"], ["\n  font-weight: 600;\n  color: ", ";\n"])), function (props) { return props.theme.colors.textBodyMain; });
var InfoRow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: 4px;\n  align-items: baseline;\n\n  & > :first-child {\n    flex: 1;\n  }\n\n  &.withMargin {\n    margin-bottom: 16px;\n  }\n"], ["\n  display: flex;\n  margin-bottom: 4px;\n  align-items: baseline;\n\n  & > :first-child {\n    flex: 1;\n  }\n\n  &.withMargin {\n    margin-bottom: 16px;\n  }\n"])));
var SecondBlock = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 20px;\n"], ["\n  margin-top: 20px;\n"])));
var LargeTitle = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32px;\n  margin-right: 8px;\n"], ["\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 32px;\n  margin-right: 8px;\n"])));
var AmountBlock = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  display: flex;\n  align-items: baseline;\n"], ["\n  color: ", ";\n  display: flex;\n  align-items: baseline;\n"])), function (props) { return props.theme.colors.textBodyMain; });
export var NFTPage = observer(function (_a) {
    var imgUrl = _a.imgUrl, name = _a.name;
    var orderFacade = useApplication().orderFacade;
    var fee = orderFacade.exchangeInfo.fee;
    var amounts = orderFacade.exchangeInfo.amounts;
    var hasEstimateRateError = orderFacade.errors.estimate;
    return (_jsxs(PageLayout, __assign({ headerLabel: name ? "Buy ".concat(name) : 'Buy NFT', footer: {
            actionButtonLabel: 'Buy now',
            actionButtonDisable: hasEstimateRateError,
            actionBtnError: hasEstimateRateError
                ? 'Temporarily unavailable'
                : undefined,
            withCaption: true,
            buttonClick: function () {
                orderFacade.setStepsInfo({
                    nextStep: PhoneStep,
                    stepsHistory: [],
                });
            },
        } }, { children: [_jsx(NFTView, { url: imgUrl ? encodeURI(imgUrl) : undefined }), _jsx(InfoRow, { children: _jsx(Title, { children: name }) }), _jsxs(SecondBlock, { children: [_jsx(InfoRow, __assign({ className: "withMargin" }, { children: _jsx(AmountBlock, { children: amounts && (_jsxs(LargeTitle, { children: [amounts.from.amount, " ", amounts.from.currency.a3] })) }) })), fee && (_jsxs(Title, { children: [fee.total.inFiat.amount, " ", fee.total.inFiat.currency, " including fee"] }))] })] })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
